import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import * as Types from './types';
import * as RegisterService from '../../../services/api/register';
import { Dispatch } from 'redux';
import NavigationConfig from '../../../navigation/config';
import ApplicantListActions from '../applicant_list_reducer/actions';
import ModalActions from '../gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
/** Fetch SchemeTypes  */

class FetchSchemeTypes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_OSS_SCHEMES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_OSS_SCHEMES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_OSS_SCHEMES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegisterService.getSchemeTypes();
        dispatch(this.onSuccess(response.data));
        // if (response.message) {
        //   showToastAction(
        //     dispatch,
        //     {
        //       [LanguagesEnum.English]: response.message,
        //       [LanguagesEnum.Greek]: response.message,
        //     },
        //     'success'
        //   );
        // }
      } catch (error: any) {
        // console.log('FetchSchemeTypes Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]: error.message,
        //     [LanguagesEnum.Greek]: error.message,
        //   },
        //   'error'
        // );
      }
    };
  }
}

/** Fetch Countries */
class FetchCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegisterService.getCountriesNotInStateMember();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchCountries Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]: error.message,
        //     [LanguagesEnum.Greek]: error.message,
        //   },
        //   'error'
        // );
      }
    };
  }
}

/** Register User Action */

interface IRegisterInput {
  history: any;
  data: any;
  isAddApplicantPage: boolean;
}
class RegisterUser implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.REGISTER_USER,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.REGISTER_USER,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.REGISTER_USER,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(input: IRegisterInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        const { data, history, isAddApplicantPage } = input;
        dispatch(this.onPending());
        await RegisterService.registerUser(data);
        dispatch(this.onSuccess());
        if (!isAddApplicantPage)
          history.push(NavigationConfig.loginPage().path);
        else {
          dispatch(
            ApplicantListActions.fetchApplicantsAction({
              sortField: 'applicant_id',
              page: 0,
              pageSize: 10,
              order: 'asc',
            })
          );
          dispatch(
            ModalActions.closeModalAction({
              modalID: ModalIDs.MODAL_ADD_APPLICANT,
            })
          );
        }
      } catch (error: any) {
        // console.log('RegisterUser Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch Countries Not in Member State (include Cyprus) */
class FetchImportCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_COUNTRIES_NOT_IN_STATE_IMSID,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_COUNTRIES_NOT_IN_STATE_IMSID,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_COUNTRIES_NOT_IN_STATE_IMSID,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegisterService.getCountriesNotInStateMember('CY');
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchNonMemberStateIncludeCyp Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchSchemeTypesAction: () => new FetchSchemeTypes().action(),
  fetchCountriesAction: () => new FetchCountries().action(),
  fetchImportCountriesAction: () => new FetchImportCountries().action(),
  registerUserAction: (data: any, history: any, isAddApplicantPage: boolean) =>
    new RegisterUser().action({ data, history, isAddApplicantPage }),
};
